import { render } from "./WindowChecker.vue?vue&type=template&id=2bc6a3db"
import script from "./WindowChecker.vue?vue&type=script&lang=js"
export * from "./WindowChecker.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\Dividenduitkering-Toets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__